import { render, staticRenderFns } from "./CampaignAppPreview.vue?vue&type=template&id=5a2c4f58&scoped=true&"
import script from "./CampaignAppPreview.vue?vue&type=script&lang=ts&"
export * from "./CampaignAppPreview.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignAppPreview.vue?vue&type=style&index=0&id=5a2c4f58&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2c4f58",
  null
  
)

export default component.exports